module.exports = "<span class=\"error\" *ngIf=\"error.length > 0\">{{ error }}</span>\n<label class=\"btn btn-default btn-file full-width\">\n\t<i class=\"fa fa-upload\"></i>\n  <input (change)=\"importImage($event)\" type=\"file\" class=\"hidden\">\n  <img *ngIf=\"imagePreviewUrl\" class=\"img_preview\" src=\"{{imagePreviewUrl}}\">\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/image_import/image_import.component.html
// module id = ./src/app/modules/image_import/image_import.component.html
// module chunks = main